// extracted by mini-css-extract-plugin
module.exports = {"passwordForm":"passwordForm-e61d61724f7f11f09773699976a4043b"};